export const STATSIG_LOCATION_STRING = 'Category Browse - All';
export const STATSIG_CATEGORYBROWSE_PAGE_VIEW = `${STATSIG_LOCATION_STRING} - View - Page`;
export const STATSIG_NIGHTLIFE_LOCATION = 'Nightlife - All';
export const NIGHTLIFE_HOLIDAY_FEATURED: `${string} - ${string}` = `${STATSIG_NIGHTLIFE_LOCATION} - Click - Holiday Featured`;
export const STATSIG_SEASONAL_LOCATION = 'Seasonal - All';
export const SEASONAL_FEATURED: `${string} - ${string}` = 'Seasonal - Featured';
